import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class StepNav extends Component {
  constructor (props) {
    super(props);

    this.renderAddASpaceStep = this.renderAddASpaceStep.bind(this);
  }

  renderAddASpaceStep (mobile) {
    const { nav = {} } = this.props;
    const { stepName } = nav;

    return (
      <div id={`add-a-space-step${mobile ? '-mobile' : ''}`}>
        <span>{stepName}</span>
      </div>
    );
  }

  renderCollapse () {
    const { profile } = this.props;

    if (profile) {
      return <div>{this.renderAddASpaceStep(true)}</div>;
    }

    return (
      <div>
        <button
          type="button"
          className="navbar-toggle"
          data-toggle="collapse"
          data-target="#listing-navbar"
          aria-expanded="false"
        >
          <span className="sr-only"><FormattedMessage id='shared_component.nav.toggle_nav' defaultMessage='Toggle navigation'/></span>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </button>
      </div>
    );
  }

  render () {
    const { nav = {}, intl } = this.props;
    const { progressBarWidth } = nav;
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();

    return (
      <div className="StepNav">
        <div className="container-fluid">
          <div className="navbar-header">
            {this.renderCollapse()}
            <a id="header_link_home" className="navbar-brand" href={`/${urlPrefix}`}>
              <img
                className="brand-logo-white"
                src="/web-2/assets/images/ps_logo_white.svg?v=rb"
                alt={intl.formatMessage({ id: 'shared_component.nav.logo_alt', defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots' })}
              />
              <img
                className="brand-logo-dark"
                src="/web-2/assets/images/ps_logo_dark.svg?v=rb"
                alt={intl.formatMessage({ id: 'shared_component.nav.logo_alt', defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots' })}
              />
            </a>
          </div>

          <div className="collapse navbar-collapse" id="listing-navbar">
            {this.renderAddASpaceStep(false)}
          </div>
        </div>
        <div className="progress-bar-outer">
          <div
            className="progress-bar-inner"
            style={{ width: `${progressBarWidth}%` }}
          />
        </div>
      </div>
    );
  }
}

StepNav.propTypes = {
  nav: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  intl: intlShape
};

export default injectIntl(StepNav);
